import OrderStateEnum from 'const/OrderStateEnum';
import ArticleSubscriptionTypeEnum from 'model/ArticleSubscriptionTypeEnum';

// eslint-disable-next-line import/prefer-default-export
export function canBeAutoApproved(order: WoaRequest, account: WoaAccount) {
  if (account.onHold || order.onHold || order.state === OrderStateEnum.ON_HOLD) {
    return false;
  }

  return (
    order.articleSubscriptionType === ArticleSubscriptionTypeEnum.ONLINE_OPEN &&
    !order.isInternal &&
    !!account?.ooProcessConfiguration?.autoApproval
  );
}
